export default __webpack_public_path__ + "static/media/210315_ASM_Edit_V4.060a12d6.mp4";